import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';
import { ICommonButtonProps } from '../../../types/button';

export const DeleteButton = ({ onClick }: ICommonButtonProps) => {
  return (
    <IconButton
      onClick={() => {
        onClick();
      }}
    >
      <DeleteIcon fontSize="small" />
    </IconButton>
  );
};
